import imageCompression from 'browser-image-compression';

const options = {
    maxSizeMB: 1,
    maxWidthOrHeight: 1920,
    useWebWorker: true,
};

export const compressFile = async (file) => {
    try {
        const compressedBlob = await imageCompression(file, options);
        console.log('compressedFile instanceof Blob', compressedBlob instanceof Blob); 
        console.log(`compressedFile size ${compressedBlob.size / 1024 / 1024} MB`); 
        const compressedFile = new File([compressedBlob], compressedBlob.name)
        return compressedFile;

    } catch (error) {
        console.error('Compression failed:', error);
        return null;
    }
};
